import React from 'react';

import {leagueSortFunc} from 'rendering-commons/Sorting';
import {cssClassMap} from 'rendering-commons/SportCssMap';

import * as FavouriteState from 'constants/FavouriteState';
import * as DisplayMode from 'constants/DisplayMode';

export default class Sport extends React.Component {
    static propTypes = {
        sport: React.PropTypes.object,
        isLive: React.PropTypes.bool.isRequired,
        displayMode: React.PropTypes.object.isRequired,
        leagues: React.PropTypes.object,
        leagueElement: React.PropTypes.func,
        showBookmarks: React.PropTypes.bool,
        gridSelection: React.PropTypes.object.isRequired,
        sportClickCallback: React.PropTypes.func.isRequired,
        sportFavouriteClickCallback: React.PropTypes.func,
        leagueClickCallback: React.PropTypes.func,
        leagueFavouriteClickCallback: React.PropTypes.func,
        selectionToggleCallback: React.PropTypes.func,
        selectionToggleLeagueCallback: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {closed: true};

        this._onFavouriteClick = this._onFavouriteClick.bind(this);
        this._onExpandClick = this._onExpandClick.bind(this);
    }

    componentWillMount() {
        const {sport, gridSelection} = this.props;
        const inGridSelection = gridSelection.get('sportsExpanded').includes(sport.get('id'));

        if (inGridSelection) {
            this.setState({closed: false});
        }
    }

    componentWillReceiveProps(nextProps) {
        //const {sport, leagues, displayMode, gridSelection} = nextProps;
        const {sport, gridSelection} = nextProps;
        if (sport && gridSelection.get('sportsExpanded').includes(sport.get('id'))) {
            this.setState({closed: false});
        }
        //const sportId = sport.get('id');

        //const isChoosenSport = (displayMode.type === DisplayMode.SPORT && displayMode.id == sportId);
        //const isLeagueDisplayMode = (displayMode.type === DisplayMode.LEAGUE);
        //const isChoosenLeague = (leagues.hasIn([displayMode.id]) && leagues.getIn([displayMode.id, 'sportId']) === sportId);

    }

    _onSportClick(id, e) {
        e.preventDefault();
        this.props.sportClickCallback(id);
        this.props.selectionToggleCallback({id, showMatches: true});
    }

    _onFavouriteClick(e) {
        e.preventDefault();
        this.props.sportFavouriteClickCallback(this.props.sport);
    }

    _onExpandClick(e) {
        e.preventDefault();
        const {sport} = this.props;

        this.setState({closed: !this.state.closed});

        this.props.selectionToggleCallback({id: sport.get('id'), showMatches: false});
    }

    static renderLeague(leagueId, props) {
        const leagueProps = {
            leagueId,
            isLive: props.isLive,
            displayMode: props.displayMode,
            gridSelection: props.gridSelection,
            matchElement: props.matchElement,
            matchStatsElement: props.matchStatsElement,
            mainScoreElement: props.mainScoreElement,
            additionalScoresElement: props.additionalScoresElement,
            additionalScoreElement: props.additionalScoreElement,
            showBookmarks: props.showBookmarks,
            showMatches: props.showMatches,
            leagueClickCallback: props.leagueClickCallback,
            leagueFavouriteClickCallback: props.leagueFavouriteClickCallback,
            matchClickCallback: props.matchClickCallback,
            matchFavouriteClickCallback: props.matchFavouriteClickCallback,
            selectionToggleLeagueCallback: props.selectionToggleLeagueCallback
        };

        const LeagueElement = props.leagueElement;

        return (<LeagueElement key={leagueId} {...leagueProps} />);
    }

    render() {
        const {sport, showBookmarks, displayMode} = this.props;

        if (sport === undefined) {
            return false;
        }

        const leagues = sport.get('leagues').map(id => this.props.leagues.get(id)).sort(leagueSortFunc);
        const sportId = sport.get('id');
        const isClosed = this.state.closed;

        const isSelected = (displayMode.type === DisplayMode.SPORT && displayMode.id == sportId);

        const cls = 'sport-list-item ' + cssClassMap[sportId] + (isClosed ? ' closed' : '')
            + (isSelected ? ' selected' : '');
        const iconCls = 'sport-icon svg-' + cssClassMap[sportId];

        let favouritesCls = 'favourites';

        const favouriteState = sport.get('favouriteState');

        if (favouriteState === FavouriteState.FULL) {
            favouritesCls += ' added';
        } else if (favouriteState === FavouriteState.PARTIAL) {
            favouritesCls += ' semi';
        }

        const boundSportClick = this._onSportClick.bind(this, sportId);

        const leaguesPresent = leagues.size > 0;

        return (
            <div className={cls}>
                <div className="sport-title">
                    <span className={iconCls} onClick={boundSportClick}/>
                    {leaguesPresent &&
                    <a href="#" className="sport-expand" onClick={this._onExpandClick}>
                        {'\u00A0'}
                    </a>}
                    <a href="#" className="sport-name" onClick={boundSportClick}>
                        {sport.get('name')}
                        {!showBookmarks && sport.get('eventCount') && <span className="event-count pull-right">+{sport.get('eventCount')}</span> }
                    </a>
                    {showBookmarks &&
                        <a href="#" className={favouritesCls} onClick={this._onFavouriteClick}>{'\u00A0'}</a>
                    }
                </div>
                {!isClosed && leaguesPresent && <div className="sport-collapse">
                    {leagues.map(l => Sport.renderLeague(l.get('id'), this.props))}
                </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/Sport.jsx